import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import CheckIcon from '@8x8/oxygen-icon/icons/CheckCircleSolidIcon'

import { Flex, ColumnFlex, ColumnFlexCentered } from '~/components/common/containers'
import { H2 } from '~/components/common/headers'
import { translate } from '~/core/translate'
import { PRODUCT_ADVERTISED_FEATURES } from '~/core/constants'

const Feature = styled(Flex)`
  font-size: 15px;
  align-items: center;
  color: black;
  margin-top: 6px;
  margin-bottom: 6px;
`

const StyledCheckIcon = styled(CheckIcon).attrs({
  size: 15
})`
  flex-shrink: 0;
  margin-right: 10px;
  fill: #31B76A;
`

const Content = styled(ColumnFlex)`
  max-width: 290px;
`

const Container = styled(ColumnFlexCentered)`
  box-sizing: border-box;
  padding: 18px 16px 24px 16px;
  background-color: #F0F3F7;
  border-radius: 6px;

  ${H2} {
    color: #5e6d7a;
    margin-bottom: 8px;
  }


  @media only screen and (min-width: 768px) and (min-height: 376px) {
  }
`

const Features = ({ features }) => (
  <Container fullWidth>
    <Content>
      {features.map(feature => {
        const label = translate(PRODUCT_ADVERTISED_FEATURES[feature])

        if (!label) {
          return null
        }

        return (
          <Feature key={feature}>
            <StyledCheckIcon />
            {translate(PRODUCT_ADVERTISED_FEATURES[feature])}
          </Feature>
        )
      })}
    </Content>
  </Container>
)

Features.propTypes = {
  features: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(PRODUCT_ADVERTISED_FEATURES)))
}

export default Features
